import React, { createContext, useState, useEffect, useContext } from 'react';
import { translations } from '../translations/translations';
//AppContext.jsx in src/context/AppContext.jsx
const AppContext = createContext();

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({children}) => {
  
  const [lang, setLang] = useState('en');
  
  const t = translations[lang];
  
  useEffect(() => {
    document.body.dir = lang === 'fa' ? 'rtl' : 'ltr';
  }, [lang]);
  
  const value = {
    lang,
    setLang,
    t
  };
  
  return (
    <AppContext.Provider value={value}>
      <div>
      {children}
      </div>
    </AppContext.Provider>
  );
};